// "Get these even when Market Matrix is closed": a link to the push notification switch in
// Settings, shown only where alerts are set and only while this device has push turned off.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { currentSubscription, pushSupported } from './pushClient';
import { useI18n } from './i18n';

export function PushHint() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);
  useEffect(() => {
    let alive = true;
    if (pushSupported()) currentSubscription().then((sub) => alive && setShow(!sub)).catch(() => {});
    return () => { alive = false; };
  }, []);
  if (!show) return null;
  return (
    <p className="push-hint">
      {t('Want these alerts even when Market Matrix is closed?')} <Link to="/app/settings#notifications">{t('Turn on push notifications')} &rarr;</Link>
    </p>
  );
}
